<template>
  <v-dialog v-model="dialog" max-width="700px" persistent scrollable>
    <v-card>
      <v-toolbar dark color="primary" elevation="0">
        <v-icon large class="mr-2">mdi-domain</v-icon>
        <v-toolbar-title class="text-h5"
          >Información del Complejo</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon dark @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>

      <v-card-text class="pt-6" v-if="!loading && institucion">
        <!-- Mapa de Google -->
        <div v-if="institucion.latitud && institucion.longitud" class="mb-4">
          <GmapMap
            :center="{
              lat: institucion.latitud,
              lng: institucion.longitud,
            }"
            :zoom="15"
            map-type-id="roadmap"
            style="width: 100%; height: 300px"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
            }"
          >
            <GmapMarker
              :position="{
                lat: institucion.latitud,
                lng: institucion.longitud,
              }"
              :clickable="true"
              :draggable="false"
            />
          </GmapMap>
        </div>

        <v-list two-line>
          <v-list-item v-if="institucion.nombre">
            <v-list-item-icon>
              <v-icon color="primary">mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-h6">{{
                institucion.nombre
              }}</v-list-item-title>
              <v-list-item-subtitle>Nombre del Complejo</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="institucion.nombre"></v-divider>

          <v-list-item v-if="institucion.direccion">
            <v-list-item-icon>
              <v-icon color="primary">mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ institucion.direccion }}</v-list-item-title>
              <v-list-item-subtitle>Dirección</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action
              v-if="institucion.latitud && institucion.longitud"
            >
              <v-btn
                icon
                :href="`https://www.google.com/maps/search/?api=1&query=${institucion.latitud},${institucion.longitud}`"
                target="_blank"
                color="red"
              >
                <v-icon>mdi-google-maps</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider v-if="institucion.direccion"></v-divider>

          <v-list-item v-if="institucion.celular">
            <v-list-item-icon>
              <v-icon color="primary">mdi-cellphone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ institucion.celular }}</v-list-item-title>
              <v-list-item-subtitle>Celular</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon :href="'tel:' + institucion.celular" color="success">
                <v-icon>mdi-phone</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider v-if="institucion.celular"></v-divider>

          <v-list-item v-if="institucion.telefono">
            <v-list-item-icon>
              <v-icon color="primary">mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ institucion.telefono }}</v-list-item-title>
              <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon :href="'tel:' + institucion.telefono" color="success">
                <v-icon>mdi-phone</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider v-if="institucion.telefono"></v-divider>

          <v-list-item v-if="institucion.mail">
            <v-list-item-icon>
              <v-icon color="primary">mdi-email</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ institucion.mail }}</v-list-item-title>
              <v-list-item-subtitle>Email</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon :href="'mailto:' + institucion.mail" color="primary">
                <v-icon>mdi-email-send</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider v-if="institucion.mail"></v-divider>

          <v-list-item
            v-if="institucion.sitioWeb && institucion.sitioWeb != 'Sin Datos'"
          >
            <v-list-item-icon>
              <v-icon color="primary">mdi-web</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <a
                  :href="institucion.sitioWeb"
                  target="_blank"
                  class="text-decoration-none"
                >
                  {{ institucion.sitioWeb }}
                </a>
              </v-list-item-title>
              <v-list-item-subtitle>Sitio Web</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                icon
                :href="institucion.sitioWeb"
                target="_blank"
                color="primary"
              >
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-alert
          v-if="!institucion.nombre && !institucion.direccion"
          type="info"
          text
          class="mt-4"
        >
          No hay información disponible del complejo
        </v-alert>
      </v-card-text>

      <v-card-text v-else-if="!loading && !institucion">
        <v-alert type="error" outlined>
          No se pudo cargar la información del complejo
        </v-alert>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";

export default {
  name: "InfoInstitucion",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    idInstitucion: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      institucion: null,
    };
  },
  watch: {
    visible(val) {
      this.dialog = val;
      if (val && this.idInstitucion) {
        this.cargarDatos();
      }
    },
  },
  methods: {
    async cargarDatos() {
      this.loading = true;
      try {
        const response = await axios.get(
          "/PortalPublico/BuscarDatosInstitucion",
          {
            params: {
              idInstitucion: this.idInstitucion,
            },
          },
        );

        if (response.data) {
          this.institucion = response.data;
        } else {
          showAlert({
            icon: "error",
            title: "No se pudo cargar la información del complejo",
            vm: this,
          });
        }
      } catch (error) {
        showAlert({
          icon: "error",
          title: "Error al cargar la información",
          vm: this,
        });
      } finally {
        this.loading = false;
      }
    },
    cerrar() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.v-list-item__title {
  white-space: normal;
  word-break: break-word;
}
</style>
